const settings = {
  allow: [
    'autodesk.parameter',
    'autodesk.revit.category',
    'autodesk.revit.spec',
    'autodesk.revit.group',
    'autodesk.revit.internal',
    'autodesk.revit.parameter',
    'autodesk.revit.enum',
    'autodesk.range',
    'autodesk.unit',
    'autodesk.spec',
    'autodesk.fabrikam',
    'autodesk.product',
    'autodesk.design',
    'testups.lookup',
  ],
};

export default settings;
